import React from "react";
import { bookPromosData } from "../../../assets/data/data";
import {
  PromosGrid,
  PromoCard,
  PromoImage,
  PromoTitle,
} from "./BookPromos.styles";

const BookPromos = () => {
  const handleCardClick = (link) => () => window.open(link, "_blank");

  return (
    <PromosGrid container spacing={2}>
      {bookPromosData?.map((item) => (
        <PromoCard key={item.id} onClick={handleCardClick(item.link)}>
          <PromoImage src={item.image} alt={item.title || "Book Cover"} />
          <PromoTitle>{item.title}</PromoTitle>
        </PromoCard>
      ))}
    </PromosGrid>
  );
};

export default BookPromos;
